import { getInitialLang } from "../../i18n";

const initialState = {
    language: getInitialLang(),
};

export default initialState;
